var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M21.07 5.73c-1.61-.16-3.22-.28-4.84-.37v-.01l-.22-1.3c-.15-.92-.37-2.3-2.71-2.3h-2.62c-2.33 0-2.55 1.32-2.71 2.29l-.21 1.28c-.93.06-1.86.12-2.79.21l-2.04.2c-.42.04-.72.41-.68.82s.4.71.82.67l2.04-.2c5.24-.52 10.52-.32 15.82.21h.08c.38 0 .71-.29.75-.68a.766.766 0 0 0-.69-.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    stroke: "#0b75c2",
    d: "M5.68 8.75h12.64c.2 0 .398.082.543.23.14.153.219.36.208.58l-.62 10.25c-.058.792-.122 1.492-.507 2.02-.355.484-1.075.93-2.734.93H8.79c-1.658 0-2.378-.449-2.733-.935-.29-.397-.399-.892-.46-1.447l-.048-.574L4.93 9.55a.8.8 0 0 1 .158-.51l.05-.061a.75.75 0 0 1 .543-.229zm4.65 7.5c-.686 0-1.25.564-1.25 1.25s.564 1.25 1.25 1.25h3.33c.686 0 1.25-.564 1.25-1.25s-.564-1.25-1.25-1.25zm-.83-4c-.686 0-1.25.564-1.25 1.25s.564 1.25 1.25 1.25h5c.686 0 1.25-.564 1.25-1.25s-.564-1.25-1.25-1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.85d160199a4e2d540b8429124f6187cd.svg";
export { ForwardRef as ReactComponent };